//@flow
import type { ThunkAction } from '../../core/types'
import {
  MODULE,
  FETCH_CONFIG_REQUEST,
  FETCH_CONFIG_FAIL,
  FETCH_CONFIG_SUCCESS,
  CLEAR_CONFIG,
  FETCH_CONFIG_RESOURCE as ConfigResource
} from './constants'
import { isConfigLoading } from './selectors'
import { hmset, hdelAll } from '../hash'
import { batch } from '../lib/batchReducer'
import {
  startCommunication,
  endCommunication,
  clearCommunication
} from '../communication/index'
import defaultConfig from './default'

export function storeConfig(data: Object) {
  return hmset(MODULE, data)
}

export function fetchConfig(url: string = '/config.local.json'): ThunkAction {
  return async function(dispatch, getState) {
    const state = getState()
    if (isConfigLoading(state)) {
      return false
    }
    dispatch(batch(FETCH_CONFIG_REQUEST, startCommunication(ConfigResource)))
    try {
      const configResponse = await fetch(url)
      if (configResponse.ok) {
        const parsedConfig = await configResponse.json()
        dispatch(
          batch(
            FETCH_CONFIG_SUCCESS,
            storeConfig(parsedConfig),
            endCommunication(ConfigResource, true)
          )
        )
        return parsedConfig
      } else {
        dispatch(
          batch(
            FETCH_CONFIG_FAIL,
            storeConfig(defaultConfig),
            endCommunication(ConfigResource, false)
          )
        )
      }
    } catch (error) {
      console.warn('Error loading config, using defaults', error)
      dispatch(
        batch(
          FETCH_CONFIG_FAIL,
          storeConfig(defaultConfig),
          endCommunication(ConfigResource, false)
        )
      )
      return defaultConfig
    }
  }
}

export function clearConfig() {
  return batch(
    CLEAR_CONFIG,
    clearCommunication(ConfigResource),
    hdelAll(MODULE)
  )
}



// WEBPACK FOOTER //
// ./src/modules/config/actions.js